import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import VueSweetalert2 from "vue-sweetalert2";
// import VueQrcodeReader from "vue-qrcode-reader";
import moment from "moment";
import router from "./router";
import store from "./store";
import * as VueGoogleMaps from "vue2-google-maps";
import Vuetify from "vuetify";
import VuetifyGoogleAutocomplete from "vuetify-google-autocomplete";
import Croppa from "vue-croppa";
import "vue-croppa/dist/vue-croppa.css";
import "sweetalert2/dist/sweetalert2.min.css";
import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css";
import VueStripeCheckout from "vue-stripe-checkout";
localStorage.setItem("currentUser", JSON.stringify({}));
localStorage.setItem("currentUserData", JSON.stringify({}));

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCEOXvOemWbayaHWZDNAAY1VN-U7EfFohU",
    libraries: "places",
  },
});

Vue.use(Vuetify);
Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: "AIzaSyCEOXvOemWbayaHWZDNAAY1VN-U7EfFohU",
});

Vue.directive("clickable", {
  inserted: function(el) {
    el.style.cursor = "pointer";
  },
});

Vue.prototype.$moment = moment;

Vue.config.productionTip = false;

Vue.use(VueSweetalert2);
// Vue.use(VueQrcodeReader);
Vue.use(Croppa);

Vue.use(moment);

new Vue({
  vuetify,
  router,
  store,
  head: {
    meta: [
      {
        name: "viewport",
        content:
          "width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover",
      },
    ],
  },
  beforeCreate() {
    this.$store.dispatch("setFullLoaderState", true);
    this.$store.dispatch("loadSiteData").then(() => {
      this.$store.dispatch("getAppID").then(() => {
        this.$store.dispatch("initAuth");
        this.$store.dispatch("loadDefaultDateRange");
      });
    });
  },
  render: (h) => h(App),
}).$mount("#app");
